import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = checking session, false = signed out, object = signed in
    const [user, setUser] = useState(null);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
            setUser(data);
        } catch {
            setUser(false);
        }
    }, []);

    useEffect(() => {
        // Returning from Google OAuth: AuthCallback exchanges the session_id first;
        // checking /auth/me now would 401 before the cookie exists.
        if (window.location.hash?.includes("session_id=")) return;
        checkAuth();
    }, [checkAuth]);

    const signOut = useCallback(async () => {
        try {
            await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
        } catch {
            // clearing local state regardless
        }
        setUser(false);
    }, []);

    return <AuthContext.Provider value={{ user, setUser, checkAuth, signOut }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
